import './nonce.csp'
import naja from 'naja'
import modalExtension from './modal.naja'
import bootstrapExtension from './bootstrap.naja'
import titleExtension from './title.naja'
import ajaxLoaderExtension from "./ajaxLoader.naja";
import ajaxHrefExtension from './ajaxHref.naja'
import redirectExtension from './redirect.naja'
import adminControlExtension from './adminControl'
import confirmExtension from './confirm.naja'

naja.registerExtension(modalExtension);
naja.registerExtension(bootstrapExtension);
naja.registerExtension(titleExtension);
naja.registerExtension(ajaxLoaderExtension, 'ajax-loader');
naja.registerExtension(ajaxHrefExtension);
naja.registerExtension(redirectExtension);
naja.registerExtension(adminControlExtension);
naja.registerExtension(confirmExtension);
